import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";

import Slide from "./Slide";

// style rules
import SliderToggles from "./SliderToggles";

const CarouselCta = ({ slidesJson }) => {
	const [slides] = useState(JSON.parse(slidesJson));
	const [length] = useState(slides.length);
	const [currentIndex, setCurrentIndex] = useState(0);

	// used for animating the slides on toggle
	const ref = useRef(0);

	const toggleNexSlide = () => {
		if (currentIndex < length - 1) {
			ref.current++; // used for triggering animation
			return setCurrentIndex((prevState) => prevState + 1);
		}
	};

	const togglePrevSlide = () => {
		if (currentIndex > 0) {
			ref.current++; // used for triggering animation
			return setCurrentIndex((prevState) => prevState - 1);
		}
	};

	if (!slides) return null;

	return (
		<>
			<motion.div
				animate={ref.current === 0 ? {} : { opacity: [0, 1] }}
				transition={{
					duration: 0.7,
				}}
				key={ref.current}
			>
				<Slide
					togglePrevSlide={togglePrevSlide}
					toggleNexSlide={toggleNexSlide}
					slide={slides[currentIndex]}
					currentIndex={currentIndex}
					length={length}
				/>
			</motion.div>
			<SliderToggles
				slidesCount={length}
				// plus 1 to account for the array starting at 0
				currentSlide={currentIndex + 1}
				toggleNexSlide={toggleNexSlide}
				togglePrevSlide={togglePrevSlide}
			/>
		</>
	);
};

CarouselCta.propTypes = {
	slidesJson: PropTypes.string,
};

export default CarouselCta;